import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DossierService} from "../../../../services";
import {IDossierSubService} from "../IDossierSub.service";
import {DossierBasePageComponent} from "../dossierBasePage.component";
import {SvedBVDossierService} from "./svedBVDossier.service";
import {
  AlertPanelComponent,
  AlertPanelService,
  ITable,
  ITableCallBack,
  ITableItemDescriptor,
  TableSelectableComponent
} from "@amlCore/components";
import {DictionaryService, UserService} from "@amlCore/services";
import {ClientInfo, SvedBVType, SvedPredstInfoType} from "../../../../models/dossier";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FileSaverService} from "ngx-filesaver";
import { BvInfoDossierComponent } from '../components/bvInfo';


@Component({
  selector: 'app-sved-bv-dossier',
  styleUrls: ['../dossier.css'],
  templateUrl: './svedBVDossier.component.html'
})
export class SvedBVDossierComponent extends DossierBasePageComponent implements OnInit, ITable {

  modelPage: Array<ClientInfo>;
  itemDescriptor: ITableItemDescriptor;
  isTableTab = true;
  @ViewChild('tableComp', {static: true}) tableComp: TableSelectableComponent;
  @ViewChild('alertObjSave') alertObjToSave: AlertPanelComponent;

  constructor(protected dossierService: DossierService,
              protected route: ActivatedRoute,
              private svedBVDossierService: SvedBVDossierService,
              protected dictSrv: DictionaryService,
              protected router: Router,
              protected userService: UserService,
              protected alertPanelSrv: AlertPanelService,
              protected modalService: NgbModal,
              protected fSaver: FileSaverService) {
    super(dossierService, route, dictSrv, router, userService, alertPanelSrv, modalService, fSaver);
  }

  ngOnInit() {
    // Инициализация вкладки
    this.modelPage = this.initPage();

    // Описание элемента таблицы
    this.itemDescriptor = {
      create: this.svedBVDossierService.getSvedBv.bind(this.svedBVDossierService, this.modelPage),
      component: BvInfoDossierComponent,
      params: {
        typePage: this.typePage,
        clientType: () => this.clientType,
      }
    } as ITableItemDescriptor;
  }

  getBfOwnerName(code: string) {
    return this.dictSrv.getStaticDataValue('bfTypeList', code);
  }

  getService(): IDossierSubService {
    return this.svedBVDossierService;
  }

  callbackItemClosed(event: ITableCallBack) {
    this.saveTableItem(event);
  }

  onSelectChange(): void {
    this.canPrintDossier(this.tableComp.getSelectedModel() as SvedBVType[]);
  }

  onPrintClick() : void {
    this.uploadPrintForm(this.tableComp.getSelectedModel() as SvedBVType[], this.alertObjToSave);
  }

  destroy() {
    // ТУТ писать реализацию ngOnDestroy для компонента

  }
}
